import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import IntlMessages from '../../components/IntlMessage';
import {
  Button,
  Card,
  Table,
  Modal,
  Switch,
  Row,
  Col,
  Image,
  Space,
  message,
} from 'antd';
import PageTitle from '../../components/PageTitle';
import _, { debounce } from 'lodash';
import { useIntl } from 'react-intl';
import ActionBar from '../../components/ActionBar';
import postApi from '../../api/posts';
import CategoriesApi from '../../api/categories';
import PostForm from './PostForm';
import FilterBar from '../../components/FilterBar';
import Language from '../../components/Language';
import langsApi from '../../api/langs';
import LanguageForm from './LanguageForm';
import { FacebookOutlined, TwitterOutlined } from '@ant-design/icons';
import IntlMessage from '../../components/IntlMessage';

Posts.propTypes = {
  items: PropTypes.array,
};
Posts.defaultProps = {
  items: [],
};

function Posts(props) {
  const isMount = useRef(false);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(1);
  const [item, setItem] = useState(null);
  // const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(true);
  const [condition, setCondition] = useState({});
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
  });
  const [modal, setModal] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [categories, setCategories] = useState([]);
  const [code, setCode] = useState(false);
  const [LanguageModal, setLanguageModal] = useState(false);
  const [FBLoading, setFBLoading] = useState(false);
  const [TWLoading, setTWLoading] = useState(false);
  const [postId, setPostId] = useState(null);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      let items = await postApi.getAll(filter);

      setItems(items.data);
      setLoading(false);
      // setDeleting(false);
      if (total !== items.total) setTotal(items.total);
    }
    fetchData();
  }, [filter, reload]);

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObjectDeep(
        filter?.filter_name,
        filter?.filter_value
      );
      setCondition(newCondition);
    }
  }, [filter]);

  useEffect(() => {
    isMount.current = true;
    if (isMount) {
      let filter = {
        page: 1,
        limit: 1000,
        keyword: '',
        order_by: 'id',
        order_dir: 'DESC',
      };
      Promise.all([CategoriesApi.getAll(filter)])
        .then((res) => {
          let categoryData = res[0]?.data;
          if (Array.isArray(categoryData)) {
            categoryData = categoryData?.map((category) => ({
              title: `${category?.title}`,
              id: category.id,
            }));
            setCategories(categoryData);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
    return () => {
      isMount.current = false;
    };
  }, []);

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] }
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : 'id',
    });
  };

  const onFilter = debounce(async (value, title, type) => {
    if (type === 'search') {
      setFilter((filter) => {
        return { ...filter, keyword: value, page: 1 };
      });
    } else {
      const filter_obj = { ...condition, [title]: value };
      let filter_name = [];
      let filter_value = [];
      for (var key in filter_obj) {
        if (filter_obj[key]) {
          filter_name.push(key);
          filter_value.push(filter_obj[key]);
        }
      }
      setFilter((filter) => {
        return {
          ...filter,
          filter_name: filter_name,
          filter_value: filter_value,
        };
      });
    }
  }, 300);

  const onReload = () => {
    setReload((reload) => !reload);
  };

  const onOpenModal = (record = null) => {
    setModal(true);
    setItem(record);
    // console.log(record);
  };

  const onCloseModal = () => {
    setModal(false);
  };

  const intl = useIntl();

  const onChangeFeatured = async (ischecked, record) => {
    await postApi.update(record.id, {
      featured: ischecked,
      catIds: record.categories.map((d) => d.id),
      user_id: record.user_id,
      title: record.title,
    });

    setItems((items) =>
      items.map((data) => {
        if (data.id === record.id)
          return {
            ...data,
            featured: ischecked,
          };
        return data;
      })
    );
  };

  const onChangeStatus = async (ischecked, record) => {
    await postApi.update(record.id, {
      status: ischecked,
      catIds: record.categories.map((d) => d.id),
      user_id: record.user_id,
      title: record.title,
    });

    setItems((items) =>
      items.map((data) => {
        if (data.id === record.id)
          return {
            ...data,
            status: ischecked,
          };
        return data;
      })
    );
  };

  const getOrder = (order) => {
    if (order === 'ascend') return 'ASC';
    if (order === 'descend') return 'DESC';
    return 'DESC';
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onDelete = async (selectedRowKeys) => {
    // console.log('Deleted');
    await postApi.delete(selectedRowKeys).catch((error) => {
      console.error(error);
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: 'global.close' }),
      });
      setLoading(false);
    });
    setSelectedRowKeys([]);
    // setDeleting(true);
    onReload();
  };

  const onSendIndexNow = async (selectedRowKeys) => {
    const data = {
      post_ids: selectedRowKeys,
    };
    // console.log('Deleted');
    await postApi
      .sendIndexNow(data)
      .then(() => {
        Modal.success({
          title: intl.formatMessage({ id: 'global.send_success' }),
        });
      })
      .catch((error) => {
        console.error(error);
        Modal.error({
          title: error.data.message,
          okText: intl.formatMessage({ id: 'global.close' }),
        });
        setLoading(false);
      });
    setSelectedRowKeys([]);
    // setDeleting(true);
    onReload();
  };

  const onCopy = async (selectedRowKeys) => {
    // console.log('Deleted');
    if (selectedRowKeys.length > 1) {
      Modal.error({
        title: 'Please select only one row',
        okText: intl.formatMessage({ id: 'global.close' }),
      });
      return;
    }
    await postApi.copy(selectedRowKeys).catch((error) => {
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: 'global.close' }),
      });
      setLoading(false);
    });
    setSelectedRowKeys([]);
    // setDeleting(true);
    onReload();
  };

  const onOpenLanguageModal = async (record, code) => {
    if (record) {
      const items = await langsApi.getAlLanguages({
        page: 1,
        limit: 9999,
        filter_name: ['record_id', 'table', 'code'],
        filter_value: [`${record.id}`, `posts`, `${code.code}`],
      });
      // console.log('hop-addons: ', items);
      record.language = items.data;
      setItem(record);
      setCode(code);
      setLanguageModal(true);
    } else {
      setModal(true);
      setItem(record);
      // console.log(record);
    }
  };

  const onCloseLanguageModal = () => {
    setLanguageModal(false);
  };

  const handlePostToFacebook = async (id) => {
    setPostId(id);
    setFBLoading(true);
    await postApi
      .postToFacebook(id)
      .then((res) => {
        console.log(res);
        setFBLoading(false);
        if (res?.id) {
          message.success('Success');
        } else {
          message.error('failed');
        }
      })
      .catch((error) => {
        setFBLoading(false);
        console.log(error);
      });
  };

  const handlePostToTwitter = async (id) => {
    setPostId(id);
    setTWLoading(true);
    await postApi
      .postToTwitter(id)
      .then((res) => {
        console.log(res);
        setTWLoading(false);
        if (res?.data?.id) {
          message.success('Success');
        } else {
          message.error('failed');
        }
      })
      .catch((error) => {
        setTWLoading(false);
        console.log(error);
      });
  };

  const columns = [
    {
      title: <IntlMessages id="post.image" />,
      key: 'image',
      // sorter: true,
      dataIndex: 'image',
      render: (text, record) => {
        return record.image ? <Image width={50} src={record.image} /> : '';
      },
    },
    {
      title: <IntlMessages id="global.name" />,
      key: 'title',
      sorter: true,
      dataIndex: 'title',
      render: (text, record) => {
        return (
          <Space>
            <Space direction="vertical" size={4}>
              <Row>
                <Button
                  type="link"
                  size="small"
                  onClick={() => onOpenModal(record)}
                  shape="round">
                  {record.title}
                </Button>
              </Row>
              <Row>
                {/* <Language>

              </Language> */}

                <Language
                  record={record}
                  showLanguageModal={onOpenLanguageModal}
                />
              </Row>
            </Space>
          </Space>
        );
      },
    },

    {
      title: <IntlMessages id="tour.featured" />,
      key: 'featured',
      // sorter: true,
      dataIndex: 'featured',
      render: (text, record) =>
        record ? (
          <Switch
            checkedChildren={''}
            unCheckedChildren={''}
            checked={!!text}
            onChange={(ischecked) => onChangeFeatured(ischecked, record)}
          />
        ) : null,
    },
    {
      title: <IntlMessages id="global.status" />,
      dataIndex: 'status',
      width: 100,
      key: 'status',
      render: (e, record) =>
        record ? (
          <Switch
            checkedChildren={''}
            unCheckedChildren={''}
            checked={!!e}
            onChange={(ischecked) => onChangeStatus(ischecked, record)}
          />
        ) : null,
    },

    {
      title: <IntlMessages id="global.created_by" />,
      key: 'id',
      width: 50,
      sorter: true,
      dataIndex: 'id',
      render: (text, record, index) => {
        return record.created_by ? record.created_by : '';
      },
    },

    {
      title: <IntlMessages id="global.id_number" />,
      key: 'id',
      width: 20,
      sorter: true,
      dataIndex: 'id',
      render: (text, record, index) => {
        return record.id;
      },
    },
    {
      title: '',
      key: 'action',
      width: 20,
      sorter: true,
      render: (text, record, index) => {
        return (
          <Space>
            <Button
              type="primary"
              shape="circle"
              loading={record?.id === postId ? FBLoading : false}
              onClick={() => handlePostToFacebook(record?.id)}>
              <FacebookOutlined />
            </Button>
            <Button
              type="primary"
              shape="circle"
              loading={record?.id === postId ? TWLoading : false}
              onClick={() => handlePostToTwitter(record?.id)}>
              <TwitterOutlined />
            </Button>
          </Space>
        );
      },
    },
  ];

  return (
    <Card bordered={false} style={{ minHeight: '100%' }}>
      <Row justify="space-between">
        <Col>
          {' '}
          <PageTitle title={<IntlMessages id="global.posts" />} />
        </Col>

        <Col>
          <ActionBar
            onDelete={() => onDelete(selectedRowKeys)}
            isShowAddButton={true}
            onAdd={onOpenModal}
            onCopy={() => onCopy(selectedRowKeys)}
            onRefresh={() => onReload()}
            isShowPublishButtons={false}
            isShowCopyButton={true}
            isShowDeleteButton={true}
            isDisabled={!(selectedRowKeys.length > 0)}>
            {' '}
            <Button
              type="default"
              onClick={() => onSendIndexNow(selectedRowKeys)}
              disabled={!(selectedRowKeys.length > 0)}>
              <IntlMessage id="global.send_index" />
            </Button>
          </ActionBar>
        </Col>
      </Row>

      <FilterBar
        data={[
          {
            name: 'category_id',
            data: categories,
            placeholder: <IntlMessages id="global.select_category" />,
          },
        ]}
        onFilter={onFilter}
      />

      <br />

      <Table
        tableLayout="auto"
        columns={columns}
        dataSource={items}
        onChange={onChangeTable}
        rowKey="id"
        size="small"
        loading={loading}
        scroll={{
          x: 'max-content',
        }}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50'],
          total: total,
          current: filter.page,
          pageSize: filter.limit,
        }}
        rowSelection={rowSelection}
      />
      {modal ? (
        <PostForm
          open={modal}
          onClose={onCloseModal}
          currentData={item}
          onReload={onReload}
          onOpen={onOpenModal}
        />
      ) : null}
      {LanguageModal ? (
        <LanguageForm
          open={LanguageModal}
          onClose={onCloseLanguageModal}
          currentData={item}
          onReload={onReload}
          code={code}
          onOpen={onOpenLanguageModal}
        />
      ) : null}
    </Card>
  );
}

export default Posts;
